import { Routes, Route, Navigate } from "react-router-dom";
import PageNav from "../../Components/PageNav";
import OverTime from "./SubPages/OverTime";
import ByEmployee from "./SubPages/ByEmployee";
import ByClient from "./SubPages/ByClient";
import "./style.scss";

function ActivitySales() {
  return (
    <>
      <PageNav
        title="Record Counts"
        links={[
          { label: "Over Time", href: "over-time" },
          { label: "By Employee", href: "by-employee" },
          { label: "By Client", href: "by-client" },
        ]}
      />
      <div className="page">
        <Routes>
          <Route path={`over-time`} element={<OverTime />} />
          <Route path={`by-employee`} element={<ByEmployee />} />
          <Route path={`by-client`} element={<ByClient />} />
          <Route index element={<Navigate to={`over-time`} />} />
        </Routes>
      </div>
    </>
  );
}

export default ActivitySales;
